export default {
  path: '',
  props: true,
  component: () =>
    import(/* webpackChunkName: "campaign-layout" */ '../CampaignLayout.vue'),
  children: [
    {
      path: 'home',
      name: 'CampaignViewExample',
      props: true,
      component: () =>
        import(
          /* webpackChunkName: "campaign-view" */ '../views/ExampleView.vue'
        )
    }
  ]
}
